import { t as tryParse } from './index-39f51a91.js';

const parsePillsData = (data) => {
    return data
        ? data
            .filter(({ isCategory }) => !isCategory)
            .reduce((accumulator, currentFilter) => {
            const { filterRefinements = [], subcharacteristics = [], characteristicName, } = currentFilter;
            const tabularFilters = subcharacteristics.reduce((acc, { filterRefinements: tabular }) => [...acc, ...tabular], []);
            const pills = [
                ...filterRefinements.filter(({ checked }) => checked),
                ...tabularFilters.filter(({ checked }) => checked),
            ];
            return [
                ...accumulator,
                ...pills.map(({ navigationState, label }) => ({
                    navigationState,
                    label,
                    tooltip: characteristicName,
                })),
            ];
        }, [])
        : [];
};
function parseRecords(response) {
    if (!response)
        return null;
    const { richText, MainContent: [{ firstRecNum, lastRecNum, recsPerPage, totalNumRecs, records }], } = response.contents[0];
    return {
        // PESV3-4240 removing whitespaces and tags from rich text in case of data issue
        richText: (richText === null || richText === void 0 ? void 0 : richText.map((text) => text.replace(/<p>|&nbsp;|&#160;|<\/p>/g, '').trim())) || [],
        products: records
            ? {
                firstRecNum,
                lastRecNum,
                recsPerPage,
                totalNumRecs,
                records: records.map(({ attributes }) => ({
                    description: attributes['product.description'][0],
                    price: attributes['product.price'][0],
                    currency: attributes['product.currency'][0],
                    repositoryId: attributes['product.repositoryId'][0],
                    pictureUrl: attributes['product.pictureUrl'][0],
                })),
            }
            : null,
    };
}
const getPlainPropValue = (property) => {
    if (typeof property !== 'string')
        return property;
    return tryParse(property);
};

export { parseRecords as a, getPlainPropValue as g, parsePillsData as p };
